/**CORE LIBRARIES IMPORT */
import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

/**ICONS IMPORT */
import { FaLinkedinIn, FaFacebookF, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const fadeOnly = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const staggerCols = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const Footer = () => {
  return (
    <motion.section
      className="footer-section"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <motion.div className="footer-container" variants={staggerCols}>
        {/* COL 1 */}
        <motion.div className="footer-col col-1" variants={fadeOnly}>
          <div className="footer-brand">
            <span className="logo-badge">JK</span>
            <span className="footer-brand-title">JK METAL &amp; ALLOYS</span>
          </div>
          <p>
            Founded in 2019, JK Metal &amp; Alloys is a premier metal manufacturer and supplier in India. We specialize in high-purity Tin Ingots, Lead Ingots, Solder Wires, Copper Products, and Solder Sticks delivering trusted quality across India.
          </p>

          <div className="social-icons-row">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
          </div>
        </motion.div>

        {/* COL 2 */}
        <motion.div className="footer-col col-2" variants={fadeOnly}>
          <h2>Contact Info</h2>
          <p>
            <FaMapMarkerAlt style={{ color: '#38BDF8', marginRight: '8px' }} />
            <strong>Address</strong>:<br />
            Shop 18, 1st Floor, Mahesh Tenement, Nr. Holi Child School, Opp. Hirawadi BRTS Bus Stop, Thakkarbapa Nagar, Bapunagar, Ahmedabad - 382350, Gujarat, India
          </p>
          <p>
            <FaEnvelope style={{ color: '#38BDF8', marginRight: '8px' }} />
            <strong>Email</strong>:<br />
            <a href="mailto:jkmetal801@gmail.com">jkmetal801@gmail.com</a>
          </p>
          <p>
            <FaPhoneAlt style={{ color: '#38BDF8', marginRight: '8px' }} />
            <strong>Phone</strong>:<br />
            <a href="tel:+918511698600">+91 85116 98600</a> | <a href="tel:+918511696999">+91 85116 96999</a>
          </p>
        </motion.div>

        {/* COL 3 */}
        <motion.div className="footer-col col-3" variants={fadeOnly}>
          <h2>Quick Links</h2>
          <ul>
            <li><Link to='/'>Home</Link></li>
            <li><Link to='/about'>About Us</Link></li>
            <li><Link to='/products'>Products Catalog</Link></li>
            <li><Link to='/applications'>Applications &amp; Uses</Link></li>
            <li><Link to='/gallery'>Gallery</Link></li>
            <li><Link to='/contact-us'>Contact Us</Link></li>
            <li><Link to='/product-enquiry'>Request Quote</Link></li>
          </ul>
        </motion.div>

        {/* COL 4 */}
        <motion.div className="footer-col col-4" variants={fadeOnly}>
          <h2>Product Range</h2>
          <ul>
            <li><Link to='/products'>High-Purity Tin Ingots</Link></li>
            <li><Link to='/products'>Refined Lead Ingots</Link></li>
            <li><Link to='/products'>Industrial Solder Wire</Link></li>
            <li><Link to='/products'>Solder Stick (63/37 Ratio)</Link></li>
            <li><Link to='/products'>Star &amp; Long Solder Ingots</Link></li>
            <li><Link to='/products'>Copper Axe &amp; Round Bars</Link></li>
            <li><Link to='/products'>Copper Flats &amp; SS Rods</Link></li>
          </ul>
        </motion.div>
      </motion.div>

      <div className="footer-bottom">
        <p>Copyright &copy; 2026 <strong>JK Metal &amp; Alloys</strong>. All Rights Reserved. | Metal Manufacturer in India</p>
      </div>
    </motion.section>
  );
};

export default Footer;
